module.exports = __webpack_public_path__ + "img/CATEGORY ICON-11.a5f294f4.png";